export const COLUMNS = [
    {
        Header: "Field Name",
        Footer: "Field Name",
        accessor: "fieldName",
    },
    {
        Header: "Display Name",
        Footer: "Display Name",
        accessor: "displayName",
    },
    {
        Header: "Is Mobile Field",
        Footer: "Is Mobile Field",
        accessor: "IsMobileField",
    },
    {
        Header: "Is Transaction Ident",
        Footer: "Is Transaction Ident",
        accessor: "isuniqueidentifier",
    },
    {
        Header: "Is Required",
        Footer: "Is Required",
        accessor: "isrequired",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];
